import React, { Component } from 'react';
import { Row, Button, Modal, Col, Form, Container } from "react-bootstrap";
import { ModalCargando } from '../../../Utils/Modal-Cargando/ModalCargando';
import { ErrorModal } from '../../../Utils/ErrorModal/ErrorModal';
//import DEFAULT_URL from '../../../../api/url';
import { SuccessModal } from '../../../Utils/SuccessModal/SuccessModal';
import axios from 'axios';
//import { DOWNLOAD_URL }} from '../../../../api/url';
export class ModalNuevaPropuesta extends Component {
    state = {
        Nombre: '',
        Puesto: '',
        Correo: '',
        Telefono: '',
        Institucion: '',
        Archivo: '',
        selectedFile: null,
        loaded: 0,
        mensajeCargando: '',
        modalCargando: false,
        modalError: false,
        Mensaje: '',
        modalSucc: false,
        Consideracion: '',
        uniqueID: '',
        cartera: [],
    };
    changeSeleccion = (id) => {
        let seleccionado = this.state.cartera.find(cliente => cliente.Empresa_UniqueID == id);
        this.setState({ Nombre: seleccionado.ResponsableInscripcion, Correo: seleccionado.CorreoResponsable, Telefono: seleccionado.TelefonoResponsable, Institucion: seleccionado.Empresa });
    }
    ocultar = () => {
        this.setState({ modalError: false, modalSucc: false });
        this.props.onHide();
    }
    ocultarModalCargando = () => {
        this.setState({ modalCargando: false });
    }
    onChange = (evt) => {
        if (evt.target.name == 'empresa') {
            this.changeSeleccion(evt.target.value);
        } else {
            this.setState({ [evt.target.name]: evt.target.value });
        }
    }
    submit = (evt) => {
        evt.preventDefault();
        const data = new FormData();
        data.append('file', this.state.selectedFile);
        this.setState({ modalCargando: true, mensajeCargando: 'Se está subiendo el archivo al servidor, por favor espere.' })
        axios.post(process.env.REACT_APP_DEFAULT_URL+ "/api/files/upload", data, {
        }).then(res => {
            if (res.status == 200) {
                const info = {
                    Path: res.data.res,
                    Nombre: this.state.Nombre,
                    Puesto: this.state.Puesto,
                    Correo: this.state.Correo,
                    Telefono: this.state.Telefono,
                    Institucion: this.state.Institucion,
                    Archivo: process.env.REACT_APP_DOWNLOAD_URL + res.data.res,
                    Asesor: this.state.uniqueID
                };
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(info)
                };
                fetch(process.env.REACT_APP_DEFAULT_URL + '/api/create/propuesta', requestOptions)
                    .then((res) => {
                        return res.json();
                    })
                    .then(data => {
                        if (data.codigo == 200) {
                            this.setState({ modalCargando: false });
                            this.setState({ Mensaje: 'Propuesta almacenada exitosamente' });
                            this.setState({ modalSucc: true });
                            this.setState({});
                        } else {
                            this.setState({ Mensaje: data.respuesta });
                            this.setState({ modalError: true });
                        }
                    });
            } else {
                this.setState({ Mensaje: res.data });
                this.setState({ modalError: true });
            }
        });
    }
    onChangeHandler = (event) => {
        this.setState({ selectedFile: event.target.files[0], loaded: 0 });
    };
    entering = () => {
        this.setState({
            Nombre: '',
            Puesto: '',
            Correo: '',
            Telefono: '',
            Institucion: '',
            Archivo: '',
            selectedFile: null,
            loaded: 0,
            mensajeCargando: '',
            modalCargando: false,
            modalError: false,
            Mensaje: '',
            modalSucc: false,
            Consideracion: '',
            uniqueID: ''
        });
        fetch(process.env.REACT_APP_DEFAULT_URL + '/api/auth/userinfo', {cache: "no-cache",  credentials: 'include' })
            .then((res) => {
                return res.json();
            })
            .then(data => {
                this.setState({ uniqueID: data.UniqueID });
                fetch(process.env.REACT_APP_DEFAULT_URL + '/api/read/cartera/' + data.UniqueID, { cache: "no-cache" })
                    .then((res) => {
                        return res.json();
                    })
                    .then(data => {
                        this.setState({ cartera: data.rows });
                    });
            });
    }
    render() {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                scrollable
                onEnter={this.entering}
            >
                <Modal.Header closeButton style={{ backgroundColor: "#b5bad0" }}>
                    <Modal.Title id="contained-modal-title-vcenter" className="font-bold">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-plus-circle-dotted" viewBox="0 0 16 16">
                            <path d="M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                        </svg>
                        &nbsp;&nbsp;&nbsp;Registrar propuesta in house
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: "#b5bad0" }} className="cuerpo-modal-nuevo-cliente">
                    <Container>
                        <Form onSubmit={this.submit}>
                            <Row>
                                <Col xs={12} md={12}>
                                    <Form.Group className="mb-3" controlId="empresa">
                                        <Form.Label>Empresa</Form.Label>
                                        <Form.Control as="select" aria-label="Empresa" name="empresa" onChange={this.onChange}>
                                            <option value="" key="0">Seleccione el cliente (si ya existe en cartera)</option>
                                            {this.state.cartera.map(cliente => <option key={cliente.Empresa_UniqueID} value={cliente.Empresa_UniqueID}>{cliente.Empresa}</option>)}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12}>
                                    <Form.Group className="mb-3" controlId="Nombre">
                                        <Form.Label>Nombre de la persona que solicita el evento</Form.Label>
                                        <Form.Control required type="text" placeholder="Ingrese el nombre del solicitante" name="Nombre" value={this.state.Nombre} onChange={this.onChange} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Form.Group className="mb-3" controlId="Direccion">
                                    <Form.Label>Puesto de trabajo</Form.Label>
                                    <Form.Control type="text" required rows={3} style={{ resize: 'none' }} placeholder="Ingrese el puesto de trabajo del solicitante" name="Puesto" value={this.state.Puesto} onChange={this.onChange} />
                                </Form.Group>
                            </Row>
                            <Row>
                                <Col xs={12} md={12}>
                                    <Form.Group className="mb-3" controlId="Correo">
                                        <Form.Label>Correo electrónico</Form.Label>
                                        <Form.Control required type="text" placeholder="Ingrese el correo del solicitante" name="Correo" value={this.state.Correo} onChange={this.onChange} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12}>
                                    <Form.Group className="mb-3" controlId="Telefono">
                                        <Form.Label>Teléfono</Form.Label>
                                        <Form.Control required type="text" placeholder="Ingrese el teléfono del solicitante" name="Telefono" value={this.state.Telefono} onChange={this.onChange} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12}>
                                    <Form.Group className="mb-3" controlId="Institucion">
                                        <Form.Label>Nombre de la institución</Form.Label>
                                        <Form.Control required type="text" placeholder="Ingrese la institución solicitante" name="Institucion" value={this.state.Institucion} onChange={this.onChange} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Form.Group controlId="formFileMultiple" className="mb-3">
                                    <Form.Label>Seleccione el archivo con la propuesta del solicitante</Form.Label>
                                    <Form.Control required type="file" onChange={this.onChangeHandler} />
                                </Form.Group>
                            </Row>
                            <Row>
                                <Button variant="secondary" className="font-bold" type="submit">Guardar</Button>
                            </Row>
                        </Form>
                    </Container>
                </Modal.Body>
                <Modal.Footer style={{ backgroundColor: "#b5bad0" }}>
                    <Button variant="secondary" className="font-bold" onClick={this.props.onHide}>Cancelar</Button>
                </Modal.Footer>

                <ErrorModal
                    color={"#b5bad0"}
                    show={this.state.modalError}
                    onHide={this.ocultar}
                    mensaje={this.state.Mensaje}
                    consideracion={this.state.Consideracion}
                />
                <ModalCargando
                    color={"#b5bad0"}
                    show={this.state.modalCargando}
                    onHide={this.ocultarModalCargando}
                    mensaje={this.state.mensajeCargando}
                />
                <SuccessModal
                    color={"#b5bad0"}
                    show={this.state.modalSucc}
                    onHide={this.ocultar}
                    mensaje={this.state.Mensaje}
                    consideracion={this.state.Consideracion}
                    enlace={''}
                    llevaenlace={false}
                />
            </Modal>
        );
    }
}